import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { OverlayPanel } from 'primeng/overlaypanel';
import { FullCalendar } from 'primeng/fullcalendar/primeng-fullcalendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ActionItemCalendarModel, ActionItemListViewModel, ActionItemTypeModel, stateMasterModel, TracItActionCalendarSearch } from 'src/Models/TracItModel';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { ActionItemService } from 'src/Services/tracit.service';
import { CheckAuth } from 'src/Services/utility.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { AppConfig } from 'src/Services/app.config';
import { TracItSearchPanelComponent } from 'src/app/Shared/TracIt/search-panel/search-panel.component';
import { TracItAddNewActionPopupComponent } from 'src/app/Shared/TracIt/add-new-action-popup/add-new-action-popup.component';
import { TracItActionStatusPopupComponent } from 'src/app/Shared/TracIt/action-status-popup/action-status-popup.component';
import { TracItNotesPopupComponent } from 'src/app/Shared/TracIt/notes-popup/notes-popup.component';
import { TracItActionItemDetailsPopupComponent } from 'src/app/Shared/TracIt/action-item-details-popup/action-item-details-popup.component';
import { TracItEditActionPopupComponent } from 'src/app/Shared/TracIt/edit-action-popup/edit-action-popup.component';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-aiaction-calendar',
  templateUrl: './aiaction-calendar.component.html',
  styleUrls: ['./aiaction-calendar.component.css']
})

export class TractItAIActionCalendarComponent implements OnInit {
  parentSearchModel = new TracItActionCalendarSearch();
  listOfStateId: string = '';
  listOfState: stateMasterModel[];
  productId: number = 1;
  ClientSelectedTool: string;
  loginUser: any;
  chkselectAll: boolean = false;
  actionItemsList: ActionItemTypeModel[];
  tokenKey: string = '';
  events: ActionItemCalendarModel[];
  options: any;
  appModel: any;
  actionTypes: string = '';
  carrierCategories: string = '';
  actionSatus: string = '';
  isListShow: boolean = false;
  defaultView: string = 'dayGridMonth';
  showDescription: boolean = true;

  listView: ActionItemListViewModel[];
  whereCondition: any = 'null';
  orderBy: any = '';
  totalPageSize: any = 0;
  isAscending: boolean = true;

  upDowDeadlineDateCSS: string = '';
  upDowStateCSS: string = '';
  upDowTypeCSS: string = '';
  upDowCategoryCSS: string = '';
  upDowStatusCSS: string = '';
  upDowNotesCSS: string = '';

  actionId: number = 0;
  updateId: number = 0;
  baseUrl: string
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  headerString: string = '';
  briefingId: number = 0;

  @ViewChild('ucCalendar', { static: false }) fc: FullCalendar;
  @ViewChild('search', { static: false }) search: TracItSearchPanelComponent;

  isHoverButtonClick: boolean = false;
  dashboardSummaryType: number = 0;
  dashboardCarrierCategories: number = 0;
  dashboardActionStatus: number = 0;
  isClickOnDashboard: boolean = false;

  emailActionId: string = '0';
  emailUpdateId: string = '0';
  emailDeadlineDate: string = '';
  emailProductId: number = 0;
  emailBriefingId: string = '0';

  deletedId: number = 0;
  bsRangeValue: Date[];
  isNextPrevBtnClick: boolean = false;

  isActionCompanySpecific: boolean = false;
  isInformativeOnly: boolean = false;

  isDateChange: boolean = false;
  recurranceId = 0;
  monthList = [];
  yearList = [];
  monthyearSettings = {};
  selectdMonth = [];
  selectedYear = [];
  currentYear = new Date().getFullYear();
  titleSearch: string;
  Cstartdate: string = '';
  Cenddate: string = '';

  tracItUnread: number = 0;
  tracItUnreadflag: boolean = true;

  constructor(private readonly titleService: Title,
    private readonly toastr: ToastrService,
    @Inject('BASE_URL') baseUrl,
    private readonly htmlToPdf: HtmlToPdf,
    private readonly actionServices: ActionItemService,
    private readonly checkAuth: CheckAuth,
    private readonly modalService: NgbModal,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.listOfStateId = 'null';
    this.baseUrl = baseUrl;
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');
    this.productId = ToolEnum.actionitem;
    this.loginUser = sessionStorage.getItem('UserId');
    this.actionTypes = 'null';
    this.carrierCategories = 'null';
    this.actionSatus = 'null';
    this.titleSearch = "";
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.loadCalanderSetting();

    this.titleService.setTitle('Calendar | JSi360');
    this.fillMonths();
    this.fillYear();
    this.monthyearSettings = {
      singleSelection: true,
      text: "Select",
      classes: "borderLessTextBoxGreen",
      noDataLabel: 'No record available',
      showCheckbox: false,
    };
    this.blockDocument();
    // ✅ IMPORTANT
    this.waitForTokenThenInit();
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    //if (!this.tokenKey) {
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100);
    //} 
    // else {
    //   this.afterTokenReady();
    // }
  }

  private afterTokenReady(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    if (sessionStorage.getItem('isClickOnDashboard') == 'true')
      this.isClickOnDashboard = true;
    else
      this.isClickOnDashboard = false;
    sessionStorage.removeItem('isClickOnDashboard');

    this.GetActionUpdates();

    ApplicationActivityStore(
      'View',
      'Trac It - Calendar ',
      this.appActivity,
      ToolEnum.actionitem,
      ActionActivity['Trac It'],
      '/trac-it/Calendar'
    );

    this.tryInitAfterTokenAndView();
  }

  private isViewInitialized = false;
  private calendarInitialized = false;

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
    this.tryInitAfterTokenAndView();
  }
 
  private tryInitAfterTokenAndView(): void {
    if (
      this.tokenKey &&
      this.isViewInitialized &&
      !this.calendarInitialized
    ) {
      this.calendarInitialized = true;
      this.initViewDependentLogic();
    }
  }

  private initViewDependentLogic(): void {
    setTimeout(() => {
      this.setDefaultDate();
      this.setDashboardSession();
      this.bindEvents();
      this.setEmailAutoLoginParameter();

      if (
        this.emailActionId &&
        this.emailUpdateId &&
        this.emailDeadlineDate &&
        this.emailProductId > 0 &&
        this.emailBriefingId
      ) {
        this.OpenActionStatusPopup(
          this.emailActionId,
          this.emailUpdateId,
          false,
          this.emailBriefingId
        );
        this.clearEmailAutoLoginParameter();
      }
    });
  }

  setEmailAutoLoginParameter() {
    if (sessionStorage.getItem('emailProductId') != null && sessionStorage.getItem('emailProductId') != ''
      && sessionStorage.getItem('emailActionId') != '' && sessionStorage.getItem('emailActionId') != null
      && sessionStorage.getItem('emailActionId') != '' && sessionStorage.getItem('emailActionId') != null
      && sessionStorage.getItem('emailDeadlineDate') != '' && sessionStorage.getItem('emailDeadlineDate') != null
      && sessionStorage.getItem('emailBriefingId') != '' && sessionStorage.getItem('emailBriefingId') != null
    ) {

      this.emailProductId = +sessionStorage.getItem('emailProductId');
      this.emailActionId = sessionStorage.getItem('emailActionId');
      this.emailUpdateId = sessionStorage.getItem('emailUpdatedId');
      this.emailDeadlineDate = sessionStorage.getItem('emailDeadlineDate');
      this.emailBriefingId = sessionStorage.getItem('emailBriefingId');
      if (this.emailActionId != '' && this.emailUpdateId != '' && this.emailDeadlineDate != '' && this.emailProductId > 0 && this.emailBriefingId != '') {
        this.search.showHideCalendar(true);
        this.isListShow = true;
        this.productId = this.emailProductId;
        this.parentSearchModel.emailActionId = this.emailActionId;
        this.parentSearchModel.emailUpdateId = this.emailUpdateId;
        this.parentSearchModel.emailBriefingId = this.emailBriefingId;
        if (this.emailDeadlineDate !== null && this.emailDeadlineDate !== '') {
          let dddt = new Date(this.emailDeadlineDate);
          let dd1 = dddt.getDate().toString();
          if (parseInt(dd1.toString()) < 10)
            dd1 = '0' + dd1.toString();

          let mm1 = (dddt.getMonth() + 1).toString();
          if (parseInt(mm1.toString()) < 10)
            mm1 = '0' + mm1.toString();

          this.parentSearchModel.emailDeadlineDate = mm1 + '-' + dd1 + '-' + dddt.getFullYear();
          this.bsRangeValue = [dddt, dddt];
        }
      }

      sessionStorage.removeItem('emailProductId');
      sessionStorage.removeItem('emailActionId');
      sessionStorage.removeItem('emailUpdatedId');
      sessionStorage.removeItem('emailDeadlineDate');
      sessionStorage.removeItem('emailBriefingId');
    }
    else {
      if (sessionStorage.getItem('displayMessage') != null) {
        this.showMessage(sessionStorage.getItem('displayMessage') + ' - user not have access', 'Error', 'error');
        sessionStorage.removeItem('displayMessage');
      }
    }
  }

  setDashboardSession() {
    this.dashboardSummaryType = +sessionStorage.getItem('dashboardSummaryType');
    this.dashboardCarrierCategories = +sessionStorage.getItem('dashboardCarrierCategories');
    this.dashboardActionStatus = +sessionStorage.getItem('dashboardActionStatus');
    if (this.dashboardSummaryType > 0 || this.dashboardCarrierCategories > 0 || this.dashboardActionStatus > 0) {
      this.defaultView = 'customList'
      this.search.showHideCalendar(true);
      this.isListShow = true;
    }
    if ((sessionStorage.getItem('dashboardFromDate') != '' && sessionStorage.getItem('dashboardFromDate') != null) && (sessionStorage.getItem('dashboardToDate') != '' && sessionStorage.getItem('dashboardToDate') != null)) {
      this.parentSearchModel.dateFrom = sessionStorage.getItem('dashboardFromDate');
      this.parentSearchModel.toDate = sessionStorage.getItem('dashboardToDate');
      let CurrentTime = new Date(this.parentSearchModel.dateFrom);
      let EndTime = new Date(this.parentSearchModel.toDate);
      this.bsRangeValue = [CurrentTime, EndTime];
      sessionStorage.removeItem('dashboardFromDate');
      sessionStorage.removeItem('dashboardToDate');
    }
    sessionStorage.removeItem('dashboardSummaryType');
    sessionStorage.removeItem('dashboardCarrierCategories');
    sessionStorage.removeItem('dashboardActionStatus');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  loadCalanderSetting() {
    this.options = {
      editable: false,
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      defaultView: this.defaultView,
      displayEventTime: false,
      displayEventEnd: false,
      minTime: '00:00:00',
      maxTime: '00:00:00',
      views: {
        dayGrid: {
          eventLimit: 4
        }
      },
      header: {
        left: 'prev,next, today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,customList'
      },
      buttonText:
      {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        list: 'List'
      },
      customButtons: {
        customList: {
          text: "List",
          click: r => {
            this.defaultView = 'customList'
            this.unBindEvents();
            this.search.showHideCalendar(true);
            this.listView = [];
            this.set120Day();
            this.isListShow = true;
            this.sort("DeadlineDate");
          }
        },
      },
      eventRender: function (event, element, view) {

      },
      eventAfterRender: function (event, element, view) {

      }
    };
  }

  set120Day() {

  let CurrentTime = new Date(this.fc.calendar.view.currentStart);

  var firstDay = new Date(CurrentTime.getFullYear(), CurrentTime.getMonth(), 1);
  firstDay.setDate(firstDay.getDate() - 30);

  var lastDay = new Date(
    CurrentTime.getFullYear(),
    CurrentTime.getMonth(),
    this.daysInMonth(CurrentTime.getMonth() + 1, CurrentTime.getFullYear())
  );
  lastDay.setDate(lastDay.getDate() + 60);

  const fromDate = new Date(firstDay);
  let toDate = new Date(lastDay);

  // Calculate max allowed (4 months limit)
  const maxAllowedDate = new Date(
    fromDate.getFullYear(),
    fromDate.getMonth() + 4,
    fromDate.getDate()
  );

  // If exceeds limit, adjust to (maxAllowedDate - 1 day)
  if (toDate >= maxAllowedDate) {
    toDate = new Date(maxAllowedDate);
    toDate.setDate(toDate.getDate() - 1);
  }

  const aa = [
    this.pad(fromDate.getMonth() + 1),
    this.pad(fromDate.getDate()),
    fromDate.getFullYear()
  ].join('/');

  const ff = [
    this.pad(toDate.getMonth() + 1),
    this.pad(toDate.getDate()),
    toDate.getFullYear()
  ].join('/');

  this.parentSearchModel.dateFrom = aa;
  this.parentSearchModel.toDate = ff;

  this.bsRangeValue = [fromDate, toDate];
}

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  GetCalendarData(searchModel: TracItActionCalendarSearch) {
    //this.blockDocument();
    searchModel.Search = this.titleSearch;
    this.actionServices.getCalendarData(this.tokenKey, searchModel).subscribe(
      data => {
        this.unblockDocument();
        this.events = data['actionItem'];
        searchModel.toDate = this.parentSearchModel.toDate;
        searchModel.dateFrom = this.parentSearchModel.dateFrom;
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  GetListViewData() {
    this.listView = [];
    this.blockDocument();
    this.parentSearchModel.Search = this.titleSearch;
    this.actionServices.getListViewData(this.orderBy, this.parentSearchModel).subscribe(
      data => {
        this.unblockDocument();
        this.isDateChange = false;
        this.listView = data['listView'];
        if (this.listView != null) {
          if (this.listView.length > 0) {
          }
        }
        this.search.showHideCalendar(true);
        this.headerString = '';
        if (this.parentSearchModel != null) {
          if (this.parentSearchModel.toDate != '' && this.parentSearchModel.toDate != null && this.parentSearchModel.dateFrom != '' && this.parentSearchModel.dateFrom != null) {
            if (this.parentSearchModel.emailDeadlineDate != '' && this.parentSearchModel.emailDeadlineDate != null) {
              let sDate = new Date(this.parentSearchModel.emailDeadlineDate);
              let eDate = new Date(this.parentSearchModel.emailDeadlineDate);

              const start = [this.pad(sDate.getMonth() + 1), this.pad(sDate.getDate()), sDate.getFullYear()].join('/');
              const end = [this.pad(eDate.getMonth() + 1), this.pad(eDate.getDate()), eDate.getFullYear()].join('/');
              this.headerString = "Calendar Items From " + start + " To " + end;

              this.Cstartdate = start;
              this.Cenddate = end;
            }
            else {
              let sDate = new Date(this.parentSearchModel.dateFrom);
              let eDate = new Date(this.parentSearchModel.toDate);

              const start = [this.pad(sDate.getMonth() + 1), this.pad(sDate.getDate()), sDate.getFullYear()].join('/');
              const end = [this.pad(eDate.getMonth() + 1), this.pad(eDate.getDate()), eDate.getFullYear()].join('/');
              this.headerString = "Calendar Items From " + start + " To " + end;

              this.Cstartdate = start;
              this.Cenddate = end;
            }
          }
        }
      },
      error => {
        this.listView = [];
        this.unblockDocument();
      }
    );
  }

  eventClick(event: any) {

    if (event.target.className == "fc-title" || event.target.className == "fc-content") {
      let parentOffset = event.target.offsetParent;
      if (event.target.className == "fc-title") {
        parentOffset = event.target.offsetParent.offsetParent;
      }
      if (parentOffset) {
        const classes = parentOffset.className.split(' ');
        if (classes.length > 0) {
          classes.forEach((element, i) => {
            if (element.includes('event-format_')) {
              this.actionId = element.split('_')[1];
              this.updateId = element.split('_')[2];
              let companySpecific = element.split('_')[3];
              let isInformativeOnly = element.split('_')[4];
              this.briefingId = element.split('_')[5];
              if (companySpecific > 0)
                this.isActionCompanySpecific = true;
              else
                this.isActionCompanySpecific = false;

              if (isInformativeOnly > 0) {
                this.isInformativeOnly = true;
                this.OpenNoteHoverPopup();
              }
              else {
                this.isInformativeOnly = false;
                this.OpenStatusHoverPopup()
              }

            }
          });
        }
      }
    }
  }

  showCalander(defaultView: any) {
    this.clearEmailAutoLoginParameter();
    this.fc.calendar.changeView(defaultView);
    if (defaultView == 'dayGridMonth') {
      this.loadMonthData();
    }
    else if (defaultView == 'timeGridWeek') {
      this.loadWeekData();
    }

    this.defaultView = defaultView;
    this.isListShow = false;
    this.search.showHideCalendar(false);
    this.setCurrentMonthAndYear(true);
  }

  setClass(status) {
    if (status === 'Acknowledged') {
      return 'btn label label-primary  ack_message';
    } else if (status === 'Done') {
      return 'btn label label-success  done_message';
    } else if (status === 'Pending') {
      return 'btn label label-danger  btn_pendding';
    } else {
      return 'btn label label-default ign_message';
    }
  }

  hideWeekViewTimeLine() {
    try {
      const timeViewDiv = this.fc.el.nativeElement.getElementsByClassName('fc-time-grid-container');
      if (timeViewDiv.length > 0) {
        timeViewDiv[0].style = "display:none";
      }
    } catch (error) {
    }
  }

  sort(sortBy: string) {
    this.upDowDeadlineDateCSS = '';
    this.upDowStateCSS = '';
    this.upDowTypeCSS = '';
    this.upDowCategoryCSS = '';
    this.upDowStatusCSS = '';
    this.upDowNotesCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active-up';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active-up';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active-up';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active-up';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active-up';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active-up';
      }
    }
    this.GetListViewData();
  }

  selectCar(event, overlaypanel: OverlayPanel) {
    overlaypanel.toggle(event);
  }

  parentFun(searchModel: TracItActionCalendarSearch) {

    this.parentSearchModel.actionTypeIds = searchModel.actionTypeIds;
    this.parentSearchModel.carrierCatIds = searchModel.carrierCatIds;
    this.parentSearchModel.isNeworChanged = searchModel.isNeworChanged;
    this.parentSearchModel.stateIds = searchModel.stateIds;
    this.parentSearchModel.statusIds = searchModel.statusIds;
    this.parentSearchModel.userId = searchModel.userId;
    this.parentSearchModel.emailDeadlineDate = searchModel.emailDeadlineDate;
    this.parentSearchModel.isFavorite = searchModel.isFavorite;
    this.parentSearchModel.isMyTracIt = searchModel.isMyTracIt;
    this.parentSearchModel.companySpecificIds = searchModel.companySpecificIds;
    if (this.defaultView === 'dayGridMonth' || this.defaultView === 'timeGridWeek') {
      if (this.fc != null && this.fc != undefined && !this.isClickOnDashboard) {
        const d = new Date(this.fc.calendar.view.activeStart);
        const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

        const e = new Date(this.fc.calendar.view.activeEnd);
        const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');
        searchModel.toDate = f;
        searchModel.dateFrom = a;

        this.set120Day();
      }
    }
    else {

      if (searchModel.toDate && searchModel.dateFrom) {
        if (searchModel.toDate != undefined && searchModel.dateFrom != undefined) {
          this.parentSearchModel.dateFrom = searchModel.dateFrom;
          this.parentSearchModel.toDate = searchModel.toDate;
        }
      }
      else {
        searchModel.dateFrom = this.parentSearchModel.dateFrom;;
        searchModel.toDate = this.parentSearchModel.toDate;
      }
    }

    if (!this.isListShow) {
      this.GetCalendarData(searchModel);
    } else {
      this.GetListViewData();
    }
  }

  showdescription($event) {
    this.showDescription = $event.srcElement.checked;
  }

  setDefaultDate() {
    if (this.fc != null && this.fc != undefined && !this.isClickOnDashboard) {
      const d = new Date(this.fc.calendar.view.currentStart);
      const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

      const e = new Date(this.fc.calendar.view.currentEnd);
      const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
    }
  }

  clearEmailAutoLoginParameter() {
    this.emailActionId = '';
    this.emailUpdateId = '';
    this.emailDeadlineDate = '';
    this.emailProductId = 0;
    this.parentSearchModel.emailActionId = '0';
    this.parentSearchModel.emailUpdateId = '0';
    this.parentSearchModel.emailDeadlineDate = '';
    this.emailBriefingId = '';
    this.search.showHideCalendar(false);
  }

  bindEvents() {

    const prevButton = this.fc.el.nativeElement.getElementsByClassName('fc-prev-button');
    const nextButton = this.fc.el.nativeElement.getElementsByClassName('fc-next-button');
    const todayButton = this.fc.el.nativeElement.getElementsByClassName('fc-today-button');
    const monthButton = this.fc.el.nativeElement.getElementsByClassName('fc-dayGridMonth-button');
    const weekButton = this.fc.el.nativeElement.getElementsByClassName('fc-timeGridWeek-button');

    nextButton[0].addEventListener('click', () => {
      this.clearEmailAutoLoginParameter();

      const d = new Date(this.fc.calendar.view.activeStart);
      const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');
      const e = new Date(this.fc.calendar.view.activeEnd);
      const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
      this.bsRangeValue = [d, e];
      this.set120Day();
      this.GetCalendarData(this.parentSearchModel);
      this.setCurrentMonthAndYear();
    });

    prevButton[0].addEventListener('click', () => {
      this.clearEmailAutoLoginParameter();
      const d = new Date(this.fc.calendar.view.activeStart);
      const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');
      const e = new Date(this.fc.calendar.view.activeEnd);
      const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
      this.bsRangeValue = [d, e];
      this.set120Day();
      this.GetCalendarData(this.parentSearchModel);
      this.setCurrentMonthAndYear();
    });

    todayButton[0].addEventListener('click', () => {

      this.clearEmailAutoLoginParameter();


      const d = new Date(this.fc.calendar.view.currentStart);
      const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

      const e = new Date(this.fc.calendar.view.currentEnd);
      const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
      this.set120Day();
      this.GetCalendarData(this.parentSearchModel);
      this.setCurrentMonthAndYear();
    });

    monthButton[0].addEventListener('click', () => {

      this.clearEmailAutoLoginParameter();
      this.set120Day();
      this.loadMonthData();
    });

    weekButton[0].addEventListener('click', () => {

      this.clearEmailAutoLoginParameter();
      this.set120Day();
      this.loadWeekData();
    });
  }

  loadMonthData() {
    this.GetCalendarData(this.parentSearchModel);
  }

  loadWeekData() {

    const d = new Date(this.fc.calendar.view.currentStart);
    const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

    const e = new Date(this.fc.calendar.view.currentEnd);
    const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

    this.parentSearchModel.dateFrom = a;
    this.parentSearchModel.toDate = f;
    this.hideWeekViewTimeLine();
    this.GetCalendarData(this.parentSearchModel);
  }

  unBindEvents() {
    const prevButton = this.fc.el.nativeElement.getElementsByClassName('fc-prev-button');
    const nextButton = this.fc.el.nativeElement.getElementsByClassName('fc-next-button');
    const todayButton = this.fc.el.nativeElement.getElementsByClassName('fc-today-button');
    const monthButton = this.fc.el.nativeElement.getElementsByClassName('fc-dayGridMonth-button');
    const weekButton = this.fc.el.nativeElement.getElementsByClassName('fc-timeGridWeek-button');

    prevButton[0].removeEventListener('click', () => {
    });
    nextButton[0].removeEventListener('click', () => {
    });
    todayButton[0].removeEventListener('click', () => {
    });
    monthButton[0].removeEventListener('click', () => {
    });
    weekButton[0].removeEventListener('click', () => {
    });
  }

  openAddNewActionItemPopup() {
    sessionStorage.setItem('productId', this.productId.toString());
    const modalRef = this.modalService.open(TracItAddNewActionPopupComponent, { size: 'lg', windowClass: "AddNewActionPopup" }).result.then(
      result => {
        if (result == 'Yes') {
          if (this.isHoverButtonClick) {

          }
          else
            this.GetListViewData();
          this.isHoverButtonClick = false;
          this.GetCalendarData(this.parentSearchModel);
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  OpenActionStatusPopup(actionId: any, updateId: any, isInformationOnly: boolean, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);

    if (isInformationOnly) {
      this.OpenNotesPopup(actionId, updateId, briefingId);
    }
    else {
      const modalRef = this.modalService.open(TracItActionStatusPopupComponent, { size: 'lg', windowClass: 'actionstatus-modal-window' }).result.then(
        result => {
          if (result == 'Yes' || result == 'Reload') {
            if (this.isHoverButtonClick) {
              this.GetCalendarData(this.parentSearchModel);
            }
            else
              this.GetListViewData();
            this.isHoverButtonClick = false;
          }
        },
        reason => {
          this.isHoverButtonClick = false;
        });
    }
  }

  pdfDocument() {

    if (this.listView != null) {
      if (this.listView.length > 0) {
        this.blockDocument();
        let mainURL = this.baseUrl;
        this.isShowprogressSpinner = true;
        let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
        url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
        url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
        document.getElementById("mytable").style.width = "100%";
        var html = url + document.getElementById('divPrint').innerHTML;
        //document.getElementById("mytable").style.width = "88%";

        let datestring = this.Cstartdate + " To " + this.Cenddate;
        this.htmlToPdf.CreatePDF(this.tokenKey, html, '0', this.productId, datestring).
          subscribe(data => {
            if (data['status'] == 'Success') {
              this.downloadFile('TracItCalendarItems', data['url']);
            }
          },
            error => {
              this.unblockDocument();
            }
          );

      }
      else {
        setTimeout(() => this.toastr.error('No data found to download', 'Error!'));
      }
    }
    else {
      setTimeout(() => this.toastr.error('No data found to download', 'Error!'));
    }
  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename + '.pdf');
        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  OpenNotesPopup(actionId: any, updateId: any, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(TracItNotesPopupComponent, { size: 'lg', windowClass: 'note-modal-window' }).result.then(
      result => {
        if (this.isHoverButtonClick)
          this.GetCalendarData(this.parentSearchModel);
        else
          this.GetListViewData();
        this.isHoverButtonClick = false;
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  OpenDetailPopup(actionId: any, updateId: any, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(TracItActionItemDetailsPopupComponent, { size: 'lg', windowClass: 'ActionItemDetailsPopup-modal-window' }).result.then(
      result => {
        if (result == 'Yes') {
          this.isHoverButtonClick = false;
        }
        if (result == 'Reload') {
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);
          this.isHoverButtonClick = false;
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  OpenDetailHoverPopup() {
    this.isHoverButtonClick = true;
    this.OpenDetailPopup(this.actionId, this.updateId, this.briefingId)
  }

  OpenStatusHoverPopup() {
    this.isHoverButtonClick = true;
    this.OpenActionStatusPopup(this.actionId, this.updateId, false, this.briefingId)
  }

  OpenNoteHoverPopup() {
    this.isHoverButtonClick = true;
    this.OpenNotesPopup(this.actionId, this.updateId, this.briefingId)
  }

  OpenAddNewActionItemHoverPopup() {
    this.isHoverButtonClick = true;
    this.openAddNewActionItemPopup();
  }

  setDeleteId(actionId: any, recurranceId: any) {
    this.deletedId = actionId;
    this.recurranceId = recurranceId;
  }

  DeleteActionItem(deletedId, recurranceId, type) {
    const delId = type == 1 ? deletedId : 0;
    const recId = type == 2 ? recurranceId : 0;
    this.actionServices.DeleteAction(delId, recId, this.loginUser).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('Record deleted successfully.', 'Success', 'success');
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);

          this.GetListViewData();
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  editAction(actionId) {
    sessionStorage.setItem('EditActionId', actionId);
    sessionStorage.setItem('productId', this.productId.toString());

    const modalRef = this.modalService.open(TracItEditActionPopupComponent, { size: 'lg', windowClass: "EditActionPopup" }).result.then(
      result => {
        if (result == 'Yes') {
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);

          this.GetListViewData();
          this.isHoverButtonClick = false;
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  // onValueChange(value: Date): void {
  //   const d = new Date(value[0]);
  //   const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

  //   const e = new Date(value[1]);
  //   const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');
  //   this.parentSearchModel.dateFrom = a;
  //   this.parentSearchModel.toDate = f;
  //   const timeDifference = (new Date(f)).getTime() - (new Date(a)).getTime();
  //   const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

  //   if (daysDifference <= 120) {
  //     this.parentSearchModel.emailDeadlineDate = '';
  //     this.isDateChange = true;
  //     this.GetListViewData();
  //     this.selectdMonth = this.monthList.filter(x => x.id == d.getMonth());
  //   }
  //   else {
  //     setTimeout(() => this.toastr.error('Please select dates in the range of four months only.', 'Error!'));
  //   }
  // }

  onValueChange(value: Date[]): void {

  if (!value || value.length !== 2) return;

  const fromDate = new Date(value[0]);
  const toDate = new Date(value[1]);

  // Format MM/DD/YYYY
  const a = [
    this.pad(fromDate.getMonth() + 1),
    this.pad(fromDate.getDate()),
    fromDate.getFullYear()
  ].join('/');

  const f = [
    this.pad(toDate.getMonth() + 1),
    this.pad(toDate.getDate()),
    toDate.getFullYear()
  ].join('/');

  this.parentSearchModel.dateFrom = a;
  this.parentSearchModel.toDate = f;

  // Calculate max allowed date
  const maxAllowedDate = new Date(
    fromDate.getFullYear(),
    fromDate.getMonth() + 4,
    fromDate.getDate()
  );

  // Reset time
  fromDate.setHours(0,0,0,0);
  toDate.setHours(0,0,0,0);
  maxAllowedDate.setHours(0,0,0,0);

  // IMPORTANT CHANGE: use < instead of <=
  if (toDate >= fromDate && toDate < maxAllowedDate) {

    this.parentSearchModel.emailDeadlineDate = '';
    this.isDateChange = true;

    this.GetListViewData();

    this.selectdMonth =
      this.monthList.filter(x => x.id === fromDate.getMonth());

  }
  else {

    this.toastr.error(
      'Please select dates in the range of four months only.',
      'Error!'
    );

  }
}

  OpenEditHoverPopup() {
    this.isHoverButtonClick = true;
    this.editAction(this.actionId)
  }

  OpenDeleteHoverPopup(actionId, recurranceId) {
    this.isHoverButtonClick = true;
    this.setDeleteId(actionId, recurranceId);
  }

  showListPopupHover($event, actionItemTypeId, actionId) {
    this.isHoverButtonClick = false;
    if (actionItemTypeId == 5) {
      this.actionId = actionId;
      this.OpenEditHoverPopup()
    }
  }

  fillMonths() {
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    for (let index = 0; index < 12; index++) {
      const date = new Date();
      this.monthList.push({ id: index, itemName: monthNames[index] })
      if (date.getMonth() == index)
        this.selectdMonth.push({ id: index, itemName: monthNames[index] });
    }
  }

  fillYear() {
    const date = new Date();
    var year = 2019;
    for (let index = 0; year <= date.getFullYear() + 5; index++) {
      this.yearList.push({ id: year, itemName: year })

      if (date.getFullYear() == year) {
        this.selectedYear.push({ id: year, itemName: year });
      }
      year = year + 1;
    }
  }

  onMonthChange(event) {
    if (event) {
      let monthId = 1;
      if (Array.isArray(event) && event.length == 0) {
        monthId = new Date().getMonth() + 1;
        this.selectdMonth = this.monthList.filter(x => x.id == monthId - 1);
      }
      else {
        monthId = event.id + 1;
        if (this.selectdMonth.length == 0)
          this.selectdMonth = this.monthList.filter(x => x.id == monthId - 1);
      }
      const d = new Date(this.fc.calendar.view.activeStart);
      const a = [d.getFullYear(), this.pad(monthId), '01'].join('-');
      const e = new Date(this.fc.calendar.view.activeEnd);
      const f = [e.getFullYear(), this.pad(monthId), this.pad(new Date(e.getFullYear(), monthId, 0).getDate())].join('-');
      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
      this.bsRangeValue = [d, e];
      this.fc.getCalendar().gotoDate(a);
      this.set120Day();
      this.GetCalendarData(this.parentSearchModel);
    }
  }

  onChangeYear(event) {
    this.currentYear = +event.itemName;
    const year = this.currentYear;
    const d = new Date(this.fc.calendar.view.currentStart);
    const a = [year, this.pad(d.getMonth() + 1), '01'].join('-');
    const e = new Date(this.fc.calendar.view.currentEnd);
    const f = [year, this.pad(e.getMonth() + 1), this.pad(new Date(year, e.getMonth(), 0).getDate())].join('-');
    this.parentSearchModel.dateFrom = a;
    this.parentSearchModel.toDate = f;
    this.bsRangeValue = [d, e];
    this.fc.getCalendar().gotoDate(a);
    this.set120Day();
    this.GetCalendarData(this.parentSearchModel);
  }

  setCurrentMonthAndYear(currentDate = false) {
    const d = currentDate ? new Date() : new Date(this.fc.calendar.view.currentStart);
    this.selectdMonth = this.monthList.filter(x => x.id == d.getMonth());
    this.currentYear = d.getFullYear();
    this.selectedYear = [];
    this.selectedYear.push({ id: this.currentYear, itemName: this.currentYear });
  }

  FilterClear() {
    this.titleSearch = "";
    if (!this.isListShow) {
      this.GetCalendarData(this.parentSearchModel);
    } else {
      this.GetListViewData();
    }

  }

  inputFilters() {
    if (!this.isListShow) {
      this.GetCalendarData(this.parentSearchModel);
    } else {
      this.GetListViewData();
    }
  }

  GetActionUpdates(): void {
    this.tracItUnread = 0;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.actionServices.GetActionItemSearchListForUpdateCount(this.loginUser).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.tracItUnread = data["unreadReacord"];
          sessionStorage.setItem('tracItUnread', this.tracItUnread.toString());
          if (this.tracItUnread > 0) {
            sessionStorage.setItem('tracItUnreadflag', 'false');
            this.tracItUnreadflag = false;
          }
        }
      },
      error => {
        this.tracItUnread = 0;
      },
    );
  }
}
